import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { GetDashboardControleDocumentosInformationRequest, GetDashboardControleDocumentosInformationResponse } from "../daos/read/get_dashboard_controle_documentos_information";
import { IControleDocumentosService } from "./controle_documentos_service";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";

export class ControleDocumentosService implements IControleDocumentosService {
  async getDashboardControleDocumentosInformation(request: GetDashboardControleDocumentosInformationRequest): Promise<GetDashboardControleDocumentosInformationResponse> {
    try {
      const result = await axiosInstance({}).get(`/controleDocumentos/dashboard/information`);
      const response = handleAxiosResponse<GetDashboardControleDocumentosInformationResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
}